<template>
  <div>
    <div class="row__image" @click="modalIsVisible = true">
      <img class="image__elem" :src="imageSrc" />
    </div>
    <FullsizeImageModal
      :show="modalIsVisible"
      :image-src="imageSrc"
      @close="modalIsVisible = false"
    />
  </div>
</template>

<script>
import FullsizeImageModal from '@/_shared/components/modals/FullsizeImageModal';
export default {
  components: {
    FullsizeImageModal,
  },
  props: {
    name: {
      type: String,
      required: true,
    },
    subfolder: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      modalIsVisible: false,
    };
  },
  computed: {
    imageSrc() {
      const src = `${process.env.MEDIA_URL}/static/${this.subfolder}/${this.name}`;
      return src;
    },
  },
}
</script>

<style scoped>
.row__image {
  width: 100px;
  height: 100px;
  display: inline-flex;
  justify-content: center;
}

.row__image:hover,
.row__image:focus {
  cursor: pointer;
  opacity: 0.5;
  transition: 0.3s;
}
</style>



// WEBPACK FOOTER //
// src/_shared/features/table/ImageRow.vue